// src/components/Generic/InViewFade.js
import { motion } from "framer-motion";

const InViewFade = ({
  children,
  delay = 0,
  amount = 0.2,
  direction = "up", // default direction
  className = "",
}) => {
  const offsets = {
    up: { x: 0, y: 50 },
    left: { x: -50, y: 0 },
    right: { x: 50, y: 0 },
  };

  const variants = {
    hidden: { opacity: 0, ...offsets[direction] },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut", delay },
    },
  };

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount }}
    >
      {children}
    </motion.div>
  );
};

export default InViewFade;
